import React from "react";
import { useLocation, Link, Redirect } from "react-router-dom";
import { Box, Button, Typography } from "@material-ui/core";

export const NotFound: React.FC = () => {
  const location = useLocation<{ error?: string }>();

  return location.state?.error === "404" ? (
    <Box
      flexGrow={1}
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography variant="h1" component="p" paragraph>
        <Box
          component="strong"
          display="block"
          fontSize="h1.fontSize"
          fontWeight="fontWeightBold"
          color="primary.dark"
        >
          {"[404]"}
        </Box>
      </Typography>
      <Typography variant="body1" paragraph color="textSecondary">
        {"The page you're looking for doesn't exist... yet."}
      </Typography>
      <Button
        to="/"
        component={Link}
        color="primary"
        variant="contained"
        replace
        disableElevation
      >
        {"Go back to homepage"}
      </Button>
    </Box>
  ) : (
    <Redirect
      to={{
        pathname: location.pathname,
        state: {
          error: "404",
        },
      }}
    />
  );
};
